import React from 'react';
import HomePage from '../pages/homePage';
import ServicePage from '../pages/servicePage';
import ContactPage from '../pages/contactPage';

export const Routes = [
	{
		isExact: true,
		path: '/',
		component: <HomePage />,
	},
	{
		path: '/service',
		component: <ServicePage />,
	},
	{
		path: '/contact',
		component: <ContactPage />,
	},
];
